module.exports = __webpack_public_path__ + "img/galery-kx5600-2-zoom.b3da6c56.png";